import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([]);

const BaBFooter = helpers.defineMultiStyleConfig({
  baseStyle: {
    CreateBundleFooter: {
      position: 'absolute',
      left: '0',
      bottom: '0',
      borderTop: '1px solid #ccc',
      backgroundColor: '#fff',
      minHeight: '80px',
      width: '100%',
      padding: '1rem',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    CreateBundleButtonInfo: {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '2rem',
    },
  },
  variants: {
    absolute: {
      CreateBundleFooter: {
        position: 'absolute',
        left: '0',
        bottom: '0',
        width: '100%',
        zIndex: 10,
      },
    },
    relative: {
      CreateBundleFooter: {
        position: 'relative',
        width: '100%',
      },
    },
    grid: {
      CreateBundleFooter: {
        position: 'relative',
        width: '100%',
      },
    },
    flex: {
      CreateBundleFooter: {
        position: 'relative',
        width: '100%',
      },
    },
  },
  defaultProps: {
    variant: 'absolute',
  },
});

export default BaBFooter;
